"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createStyled = _interopRequireDefault(require("./createStyled"));

const styled = (0, _createStyled.default)();
var _default = styled;
exports.default = _default;